import axios from 'axios';
import { getApiKeyFromLocalStorage, getBaseURL, getWorkingEndpoint } from './apiClient';
import { getEndpoints } from './endpointService';

export const checkHealthAcrossEndpoints = async () => {
  try {
    const apiKey = getApiKeyFromLocalStorage();
    if (!apiKey) {
      return { isHealthy: null, services: [], timestamp: null };
    }

    const endpoints = await getEndpoints();

    for (const endpoint of endpoints) {
      try {
        const healthUrl = `https://${endpoint}/api/health`;
        const response = await axios.get(healthUrl, {
          headers: {
            'x-api-key': apiKey
          },
          timeout: 10000
        });

        if (response.status === 200 && response.data.data.status) {
          const allServicesHealthy = response.data.data.services.every(
            service => service.status === true
          );
          if (allServicesHealthy) {
            return {
              isHealthy: true,
              services: response.data.data.services,
              timestamp: response.data.data.timestamp,
              endpoint: endpoint
            };
          }
        }
      } catch (error) {
        console.warn(`Health check failed for ${endpoint}:`, error.message);
      }
    }

    return { isHealthy: false, services: [], timestamp: null };
  } catch (error) {
    console.error('Endpoints health validation failed:', error);
    
    try {
      const healthUrl = `${getBaseURL()}/health`;
      const response = await axios.get(healthUrl, {
        headers: {
          'x-api-key': getApiKeyFromLocalStorage()
        },
        timeout: 10000
      });

      if (response.status === 200 && response.data.data.status) {
        const allServicesHealthy = response.data.data.services.every(
          service => service.status === true
        );
        return {
          isHealthy: allServicesHealthy,
          services: response.data.data.services,
          timestamp: response.data.data.timestamp,
          endpoint: getWorkingEndpoint()
        };
      }
    } catch (fallbackError) {
      console.error('Fallback health check failed:', fallbackError);
    }
    
    return { isHealthy: false, services: [], timestamp: null };
  }
};

export const checkCurrentEndpointHealth = async () => {
  try {
    const apiKey = getApiKeyFromLocalStorage();
    if (!apiKey) {
      return { isHealthy: null, services: [], timestamp: null, endpoint: null };
    }

    const endpoint = getWorkingEndpoint();
    const healthUrl = `https://${endpoint}/api/health`;
    
    const response = await axios.get(healthUrl, {
      headers: {
        'x-api-key': apiKey
      },
      timeout: 10000
    });

    if (response.status === 200 && response.data.data.status) {
      const allServicesHealthy = response.data.data.services.every(
        service => service.status === true
      );
      return {
        isHealthy: allServicesHealthy,
        services: response.data.data.services,
        timestamp: response.data.data.timestamp,
        endpoint: endpoint
      };
    }

    return { isHealthy: false, services: [], timestamp: null, endpoint: endpoint };
  } catch (error) {
    console.error('Current endpoint health check failed:', error);
    return { isHealthy: false, services: [], timestamp: null, endpoint: getWorkingEndpoint() };
  }
};

